import cx from "classnames";
import React, { ReactNode } from "react";

import { PolymorphicComponentProps } from "../../helpers";
import * as styles from "./Column.module.css";

export type ColumnSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

interface IColumnProps {
  children?: ReactNode;
  className?: string;
  xs?: ColumnSize;
  sm?: ColumnSize;
  md?: ColumnSize;
  lg?: ColumnSize;
}
export type ColumnProps<E extends React.ElementType> = Readonly<IColumnProps> &
  PolymorphicComponentProps<E>;

/**
 * Note: Since upgrading to Razzle 4 css names are converted to camelCase. Since we are manually generating the
 * classnames here, we need to make them in camelCase format
 */
export const Column = <E extends React.ElementType>(props: ColumnProps<E>) => {
  const { className, children, xs, sm, md, lg, as: Component = "div", ...restProps } = props;
  const style = [];
  if (xs) {
    style.push(styles[`col${xs}`]);
  }

  if (sm) {
    style.push(styles[`colSm${sm}`]);
  }

  if (md) {
    style.push(styles[`colMd${md}`]);
  }

  if (lg) {
    style.push(styles[`colLg${lg}`]);
  }

  // If nothing is specified, default to an even split
  if (style.length < 1) {
    style.push(styles.col);
  }

  return (
    <Component className={cx(style, className)} {...restProps}>
      {children}
    </Component>
  );
};
